let authTokenFetcher: undefined | (() => Promise<string>);

export const getAuthToken = (): Promise<string | undefined> =>
  authTokenFetcher ? authTokenFetcher() : Promise.resolve(undefined);
export const setAuthTokenFetcher = (fetcher: () => Promise<string>): void => {
  authTokenFetcher = fetcher;
};
